<template>
  <div class="flex Card">
    <Flex><img :src="require(`../../../assets/experiencePage/${svg}`)"/></Flex>
    <Space pwidth="15px" />
    <div class="flex flex-col">
      <div class="Card-Title">{{ text.header }}</div>
      <div class="Card-Text">{{ text.text }}</div>
    </div>
  </div>
</template>

<script>
import { Flex } from '../../../layout/flexbox';
import Space from '../../../layout/space';

export default {
  components: { Flex, Space },
  props: ['text', 'svg'],
};
</script>

<style scoped>
.Card {
  --card-m-bottom: 40px;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 12px;
  padding: var(--card-padding);
  --card-f-size: 14px;
  --max-width: 330px;
  --card-font-color: #2b4047;
  --card-padding: 1.5em;
  max-width: var(--max-width);
  margin-bottom: var(--card-m-bottom);
  color: var(--card-font-color);
}
.Card-Title {
  color: var(--card-font-color);
  font-weight: 600;
  font-size: var(--card-f-size);
}
.Card-Text {
  font-size: var(--card-f-size);
}

@media (min-width: 768px) {
  .Card {
    --card-m-bottom: 0px;
  }
}
@media (min-width: 1024px) {
  .Card {
    --max-width: 290px;
  }
}
@media (min-width: 1200px) {
  .Card {
    --max-width: 380px;
  }
}
@media (min-width: 1400px) {
  .Card {
    --card-f-size: 15px;
  }
}
@media (min-width: 1650px) {
  .Card {
    --max-width: 430px;
  }
}
@media (min-width: 1800px) {
  .Card {
    --card-f-size: 20px;
    --max-width: 460px;
  }
}
</style>
